import React from "react";
import {MultiFanNoiseResults} from "./multiFanNoiseCalculations";

interface MultiFanCalculationResultsProps {
    results: MultiFanNoiseResults;
}

export function MultiFanCalculationResults({results}: MultiFanCalculationResultsProps) {
    return (
        <div style={{flex: "1", display: "flex", flexDirection: "column", gap: "20px"}}>
            <h2>Wyniki</h2>

            <div style={{overflowX: "auto"}}>
                <table className="table table-bordered table-hover" style={{fontSize: "12px"}}>
                    <thead className="table-light">
                    <tr>
                        <th>Wentylator #</th>
                        <th>Koordynat</th>
                        <th>R (promień 2D) [m]</th>
                        <th>R' (odl. 3D) [m]</th>
                        <th>SPL dB(A)</th>
                    </tr>
                    </thead>
                    <tbody>
                    {results.fanResults.map((fanResult) => (
                        <tr key={fanResult.fanNumber}>
                            <td>
                                <strong>#{fanResult.fanNumber}</strong>
                                <br/>
                                <span className="text-muted">PWL: {fanResult.pwlDba.toFixed(1)} dB(A)</span>
                            </td>
                            <td>
                                X: {fanResult.coordinates.xMeters.toFixed(2)},
                                Y: {fanResult.coordinates.yMeters.toFixed(2)},
                                Z: {fanResult.coordinates.zMeters.toFixed(2)}
                            </td>
                            <td>{fanResult.radius2D.toFixed(2)}</td>
                            <td>{fanResult.distance3D.toFixed(2)}</td>
                            <td><strong>{fanResult.splDba.toFixed(2)}</strong></td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>

            <div
                style={{
                    padding: "20px",
                    backgroundColor: "#e3f2fd",
                    border: "2px solid #1976d2",
                    borderRadius: "8px",
                    textAlign: "center"
                }}
            >
                <h4 className="mb-2">SPL TOT (w punkcie obserwatora)</h4>
                <div style={{fontSize: "32px", fontWeight: "bold", color: "#1976d2"}}>
                    {results.splTotalDba.toFixed(2)} dB(A)
                </div>
                <p>(±2 dB(A); w polu swobodnym)</p>
            </div>

            <table className="table table-bordered" style={{fontSize: "12px"}}>
                <tbody>
                    <tr>
                        <td>O<sub>pom.</sub> od obwiedni po x</td>
                        <td><strong>{results.odlegloscPomiarowaOdObwiedniPoX.toFixed(2)} m</strong></td>
                    </tr>
                    <tr>
                        <td>O<sub>pom.</sub> od obwiedni po y</td>
                        <td><strong>{results.odlegloscPomiarowaOdObwiedniPoY.toFixed(2)} m</strong></td>
                    </tr>
                    <tr>
                        <td>Suma mocy akustycznych (wentylator + zadana dodatkowa)</td>
                        <td><strong>{results.sumOfFanPwlAndUserGivenFanPwlDba.toFixed(2)} dB(A)</strong></td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}
